/**
 * Thermometer — horizontal fill bar for session progress + campaign bars.
 *
 * Pure function; returns a new HTMLElement each call so panels can simply
 * replace the element in the DOM. Width-fill transition is driven by
 * var(--sig-motion-thermometer) on the `.ag-thermo__fill` class in
 * styles.css; the fill colour defaults to var(--ag-primary) but can be
 * overridden per-instance via the `color` option.
 */

export interface ThermometerOptions {
  /** 0.0 → 1.0. Values outside the range are clamped. */
  readonly percent: number;
  /** Optional accent override (defaults to CSS --ag-primary). */
  readonly color?: string;
  /** Bar height variant; defaults to 'md' (40px equiv via CSS). */
  readonly size?: 'md' | 'lg';
}

export function renderThermometer(opts: ThermometerOptions): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = opts.size === 'lg' ? 'ag-thermo ag-thermo--lg' : 'ag-thermo';
  const fill = document.createElement('div');
  fill.className = 'ag-thermo__fill';
  const clamped = Math.max(0, Math.min(1, opts.percent));
  fill.style.width = `${(clamped * 100).toFixed(1)}%`;
  if (opts.color) fill.style.background = opts.color;
  wrap.appendChild(fill);
  return wrap;
}
